import { useState, useEffect, useContext } from "react"
import { useNavigate } from "react-router-dom"
import intl from "react-intl-universal"

import ContentBlank from "../../molecules/ContentBlank/index"
import styles from "./index.module.scss"
import DashboardIcon from "../../../assets/icons/DashboardIcon"
import imgfNoPanels from "../../../assets/img/no-panels-illustration.svg"
import notAccessImage from "../../../assets/img/no-access-page.svg"
import RcmpCardPanel from "../../molecules/CardPanel"
import RcmpAddCard from "../../molecules/AddCard"
import PaineisContext from "../../../contexts/Paineis"
import InfiniteScroll from "../../atoms/InfiniteScroll"
import RcmpLoading from "../../atoms/Loading"
import TabsSelectedPanels from "../../organisms/TabsSelectedPanels"
import RcmpEmptyContentPage from "../../molecules/EmptyContentPage"

import AZFilterIcon from "../../../assets/icons/AZFilterIcon"
import ZAFilterIcon from "../../../assets/icons/ZAFilterIcon"
import EarlyFilterIcon from "../../../assets/icons/EarlyFilterIcon"
import LateFilterIcon from "../../../assets/icons/LateFilterIcon"
import { fnBisAdmin } from "../../../utils/permissions"
import { searchHighlight } from "../../../utils/search"
import RcmpHeader from "../../atoms/Header"
import RcmpModalsPanel from "../../organisms/ModalsPanel"
import RcmpNotAccessPage from "../../molecules/NotAccessPage"
import { fnDecodeStorageToken } from "../../../utils/encodeLocalStorage"

const orderParams = {
  "A-Z": `&order=name&direction=ASC`,
  "Z-A": `&order=name&direction=DESC`,
  early: `&order=created_at&direction=DESC`,
  late: `&order=created_at&direction=ASC`,
}

export default function DashboardPage() {
  const {
    paineis,
    fetchPaineis,
    handleSetSelectedPainel,
    fnSetBIsOpenAddPanel,
    bUpdatePanelsList,
    fnSetBUpdatePanelsList,
    fnSetOCurrentPanel,
  } = useContext(PaineisContext)

  const [oParams, fnSetOparams] = useState({ cSearchTerm: "", cOrder: "early" })
  const [cards, setCards] = useState([])
  const [bCloseSearchTerm, setBCloseSearchTerm] = useState(false)
  const aPermissions = fnDecodeStorageToken()?.aPermissions
  const bHasAccess = true

  const fnNavigate = useNavigate()

  const fetchPaineisWithParams = async (page) => {
    if (paineis?.loading) return
    if (page === 1) setCards([])

    const perPage = 12
    const orderParam = orderParams[oParams.cOrder] || orderParams["early"]
    const response = await fetchPaineis(
      `perPage=${perPage}&page=${page}&search=${oParams.cSearchTerm}${orderParam}`
    )

    setBCloseSearchTerm(false)

    if (page <= 1) {
      setCards(response?.data?.data || [])
      return
    }

    setCards([...cards, ...(response?.data?.data || [])])
  }

  const nextPage = async (page) => {
    await fetchPaineisWithParams(page)
  }

  useEffect(() => {
    if (!bCloseSearchTerm) return

    (async () => {
      await fetchPaineisWithParams(1)
    })()
  }, [bCloseSearchTerm])

  useEffect(() => {
    fetchPaineisWithParams(1)
  }, [oParams])

  useEffect(() => {
    if (!cards?.length) return
    searchHighlight(oParams.cSearchTerm)
  }, [oParams, cards])

  useEffect(() => {
    if (!bUpdatePanelsList) return

    fnSetOparams((prev) => ({ ...prev, cSearchTerm: "" }))
    fnSetBUpdatePanelsList(false)
  }, [bUpdatePanelsList])

  const fnHandleOpenModal = () => {
    fnSetOCurrentPanel(null)
    fnSetBIsOpenAddPanel(true)
  }

  const fnToBoard = (oPanel) => {
    fnNavigate(`/${oPanel.id}/boards`)
  }

  const fnOnSelectPanel = (oPanel) => {
    handleSetSelectedPainel(oPanel)
    fnToBoard(oPanel)
  }

  const fnOnChangeSearchTerm = (cSearchTerm) => {
    fnSetOparams((prev) => ({ ...prev, cSearchTerm }))
  }

  const fnOnChangeOrder = (cOrder) => {
    fnSetOparams((prev) => ({ ...prev, cOrder }))
  }

  const aOrderOptions = [
    {
      label: intl.get("DashboardPage.a_z_by_title"),
      value: "A-Z",
      icon: <AZFilterIcon />,
    },
    {
      label: intl.get("DashboardPage.z_a_by_title"),
      value: "Z-A",
      icon: <ZAFilterIcon />,
    },
    {
      label: intl.get("DashboardPage.most_recent"),
      value: "early",
      icon: <EarlyFilterIcon />,
    },
    {
      label: intl.get("DashboardPage.older"),
      value: "late",
      icon: <LateFilterIcon />,
    },
  ]

  const cInfo = intl.get("DashboardPage.answer")
  const cNoPanelsMessage = !paineis?.error
    ? oParams?.cSearchTerm?.length ? intl.get("DashboardPage.no_search_panel_message") : intl.get("DashboardPage.no_panel_message")
    : intl.get("DashboardPage.panels_error_message")
  const cNoPanelsActionMessage =
    !paineis?.error && fnBisAdmin()
      ? intl.get("DashboardPage.no_panels_action_message")
      : ""

  const fnHandleCanCreatePanel = fnBisAdmin() ? fnHandleOpenModal : null

  if (!bHasAccess) {
    return (
      <>
        <RcmpHeader
          cTitlePage={intl.get("DashboardPage.title")}
          elIcon={<DashboardIcon />}
        >
          <TabsSelectedPanels oSelectTab={null} fnOnSelectPanel={fnToBoard} />
        </RcmpHeader>
        <ContentBlank
          fnSetBisOpenModal={fnHandleCanCreatePanel}
          aOrderOptions={aOrderOptions}
          // sButtonLabel={intl.get("DashboardPage.new_panel")}
          bDisableActions={true}
        >

          {aPermissions?.length ?
            <RcmpNotAccessPage
              bShow={fnBisAdmin()}
              cMessage={intl.get("no_access_page")}
              image={notAccessImage}
            /> : <RcmpLoading bShow={true} />
          }
        </ContentBlank>

      </>
    )
  }


  return (
    <>
      <RcmpHeader
        cTitlePage={intl.get("DashboardPage.title")}
        elIcon={<DashboardIcon />}
      >
        <TabsSelectedPanels oSelectTab={null} fnOnSelectPanel={fnToBoard} />
      </RcmpHeader>
      <ContentBlank
        fnSetBisOpenModal={fnHandleCanCreatePanel}
        setSearchTerm={fnOnChangeSearchTerm}
        onChangeOrder={fnOnChangeOrder}
        selectedOrder={oParams.cOrder}
        aOrderOptions={aOrderOptions}
        sButtonLabel={intl.get("DashboardPage.new_panel")}
        bCloseSearchTerm={bCloseSearchTerm}
        bHasVideoTutorial={true}
      >
        <div className={styles.cardsContainer}>
          <InfiniteScroll
            fnNext={nextPage}
            nTotalPages={paineis?.data?.data?.last_page}
            nDataLength={cards.length}
            bStopPagination={paineis?.error || paineis?.loading}
          >
            <div className={styles.cards}>
              {cards?.map((oPanel) => (
                <RcmpCardPanel
                  key={oPanel.id}
                  oCard={oPanel}
                  onClick={() => fnOnSelectPanel(oPanel)}
                />
              ))}
              {cards?.length > 0 && fnBisAdmin() && (
                <RcmpAddCard
                  cLabel={intl.get("DashboardPage.new_panel")}
                  onClick={fnHandleOpenModal}
                  style={{ height: 195 }}
                />
              )}
            </div>
          </InfiniteScroll>
          <RcmpEmptyContentPage
            bShow={(!paineis?.loading && !cards?.length) || paineis?.error}
            cMessage={cNoPanelsMessage}
            cActionMessage={cNoPanelsActionMessage}
            fnOnAction={fnHandleOpenModal}
            cQuestion={intl.get("DashboardPage.what_is_panel")}
            cAnswer={cInfo}
            image={imgfNoPanels}
          />
        </div>
        <RcmpLoading bShow={paineis?.loading} />
        <RcmpModalsPanel />
      </ContentBlank>
    </>
  )
}
